const React = require('react');
const Swipe = require('../../Swipe');
const ENABLE_SWIPE_WIDTH = 768;

class Cards extends React.Component {
    constructor(props) {
        super(props);
        this.handleResize = this.handleResize.bind(this);
        this.renderCards = this.renderCards.bind(this);
        this.state = {
            windowWidth: 0,
            selected: 0
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        const { innerWidth } = window;
        this.setState({ windowWidth: innerWidth });
    }

    renderCards(cards) {
        return cards.map((card, i) => {
            const cardClasses = [].concat('cards__card', card.leftAligned ? 'cards__card--left-aligned' : null).join(' ');
            return (
            <div className="cards__card-wrapper" key={i}>
                <div className={cardClasses}>
                    {card.image && (
                    <div className="cards__image-container">
                        <img src={card.image} className="cards__card-image"/>
                    </div>
                    )}
                    <h2 className="cards__title">{card.title}</h2>
                    {card.description && <p className="cards__description">{card.description}</p>}
                    {card.link && <a className="cards__link" href={card.link}>les mer</a>}
                </div>
            </div>
            )
        });
    }

    render() {
        const { cards } = this.props;
        const { windowWidth } = this.state;
        return (
        <section className="cards">
            {(ENABLE_SWIPE_WIDTH >= windowWidth) ?
             <div className="cards__container">
                 <Swipe options={{loop: false, centeredSlides: true, slidesPerView: 'auto'}} pagination={true}>
                    {this.renderCards(cards)}
                 </Swipe>
             </div>
             : (
             <div className="cards__container">
                 {this.renderCards(cards)}
             </div>
             )}
        </section>
        )
    }
}

module.exports = Cards;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/cards/Component/index.jsx